import { render, staticRenderFns } from "./QuantityBadge.vue?vue&type=template&id=222307c9&scoped=true"
import script from "./QuantityBadge.vue?vue&type=script&lang=js"
export * from "./QuantityBadge.vue?vue&type=script&lang=js"
import style0 from "./QuantityBadge.vue?vue&type=style&index=0&id=222307c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222307c9",
  null
  
)

export default component.exports